import Vue from 'vue'
import Router from 'vue-router'

// Pages
import Home from '@/pages/Home'

import Tests from '@/pages/Tests'

import Interested from '@/pages/Interested'
import About from '@/pages/About'
import HowItWorks from '@/pages/HowItWorks'

import Terms from '@/pages/Terms'
import Login from '@/pages/Login'
import ForgottenPassword from '@/pages/ForgottenPassword'
import Logout from '@/pages/Logout'
import Matches from '@/pages/Matches'
import Everyone from '@/pages/Everyone'
import Favourites from '@/pages/Favourites'

import Chats from '@/pages/Chats'
import UserProfile from '@/pages/UserProfile'
import CountriesExample from '@/pages/CountriesExample'
import Share from '@/pages/Share'
import Projects from '@/pages/Projects'

// Admin pages
import DeleteUser from '@/pages/DeleteUser'
import Overview from '@/pages/admin/Overview'

// Registration pages
import Register from '@/pages/Register'

// Edit Pages
import EditProfile from '@/pages/EditProfile'

import { db, auth } from '@/firebase'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    // Unprotected Pages
    {
      path: '/',
      name: 'Connect, chat and exchange knowledge to drive real change in Africa',
      component: Home
    },
    // Pre launch
    {
      path: '/interested',
      name: 'Interested',
      component: Interested
    },
    {
      path: '/about',
      name: 'About',
      component: About
    },
    {
      path: '/how-it-works',
      name: 'How It Works',
      component: HowItWorks
    },
    {
      path: '/tests',
      name: 'Tests',
      component: Tests
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/forgot-password',
      name: 'ForgottenPassword',
      component: ForgottenPassword
    },
    {
      path: '/logout',
      name: 'Logout',
      component: Logout
    },
    {
      path: '/terms',
      name: 'Terms & Conditions',
      component: Terms
    },
    {
      path: '/countriesexample',
      name: 'countriesexample',
      component: CountriesExample
    },
    // Protected Pages
    {
      path: '/matches',
      name: 'Matches',
      component: Matches
    },
    {
      path: '/everyone',
      name: 'Everyone',
      component: Everyone
    },
    {
      path: '/favourites',
      name: 'Favourites',
      component: Favourites
    },
    {
      path: '/projects',
      name: 'Projects',
      component: Projects
    },
    {
      path: '/itc/:id',
      name: 'Invite to Chat',
      meta: {
        inviteToChat: true
      }
    },
    {
      path: '/chats',
      name: 'Chats',
      component: Chats
    },
    {
      path: '/chats/:id',
      name: 'Chat',
      component: Chats
    },
    {
      path: '/user/:slug',
      name: 'User Profile',
      component: UserProfile,
      meta: {
        user: true
      }
    },
    {
      path: '/user/edit-profile',
      name: 'Edit Profile',
      component: EditProfile
    },
    {
      path: '/share',
      name: 'Share',
      component: Share
    },
    {
      path: '/delete-user',
      name: 'Delete User',
      component: DeleteUser
    },
    // Registration
    {
      path: '/register/:step?',
      name: 'Register',
      component: Register
    },
    // Admin pages
    {
      path: '/admin/overview',
      name: 'Overview',
      component: Overview
    }
  ]
})

const siteName = 'PEI exChange » '
let pageName = ''

router.beforeEach((to, from, next) => {
  // Slug to user ID
  if (to.meta.user) {
    pageName = 'User Profile'
    db.ref('user-meta/slug/' + to.params.slug).once('value').then(function (s) {
      to.params.uid = s.val()
      next()
    })
  } else if (to.meta.inviteToChat) {
    auth.onAuthStateChanged(function (user) {
      if (user) {
        router.push({name: 'Chat', params: { id: to.params.id }})
      } else {
        router.push({name: 'Login', params: { addtochat: to.params.id }})
      }
    })
  } else {
    pageName = to.name
    next()
  }
  document.title = siteName + pageName
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js